// @flow
const ABS_URL = /^(\w+:)?\/\//;
export function maybePrefix(url: string, baseUrl: string): string {
	if (ABS_URL.test(url)) {
		if (baseUrl.startsWith("https://sonic.pagestrip.com")) {
			return url.replace("/pagestrip.com/meta/", "/sonic.pagestrip.com/meta/");
		} else if (url.startsWith("http:") && window.location.protocol === "https:") {
			return "https:" + url.substring(5);
		}
		return url;
	}
	const slash = baseUrl.endsWith("/") || url.startsWith("/") ? "" : "/";
	return `${baseUrl}${slash}${url.startsWith("/") ? url.substr(1) : url}`;
}



// WEBPACK FOOTER //
// ./lib/api/helpers.js